import React from "react";
import styles from "./page.module.css";
import { ReactComponent as Logo } from "../../../../images/logo.svg";
import { ContinueButton } from "../../../../components/continue-button/continue-button";

const Page = (props) => {
  const buttonStyles = {
    backgroundColor: '#ffffff',
    color: '#1B1A1F',
    borderRadius: '12px'
  };
  return (
    <div className={styles.page}>
      <div>
        <div className={styles.logo}>
          <Logo />
        </div>
        <h1 className={styles.title}>{props.title}</h1>
      </div>
      {props.children}
      {!props.hideContinueButton && <ContinueButton link={props.nextPageLink} onClick={props.onContinue} enabled={props.canGoToNextPage} buttonStyles={buttonStyles}/>}
    </div>
  );
};

export { Page };
